<template>
    <div class="content_builder">
        <component
            :is="`section-${section.key}`"
            v-for="(section, index) in sections"
            :key="index"
            :value="section.value"
            :article="article"
            :exclude-from-print-class-name="excludeFromPrintClassName"
            class="content_section"
        />
    </div>
</template>

<script>
import { ArticleType } from '@/enums/articles';
import Pdf from '@/components/elements/ContentBuilder/sections/Pdf';
import Text from '@/components/elements/ContentBuilder/sections/Text';
import Form from '@/components/elements/ContentBuilder/sections/Form';
import Audio from '@/components/elements/ContentBuilder/sections/Audio';
import Video from '@/components/elements/ContentBuilder/sections/Video';
import Quote from '@/components/elements/ContentBuilder/sections/Quote';
import Header from '@/components/elements/ContentBuilder/sections/Header';
import Images from '@/components/elements/ContentBuilder/sections/Images';
import Thanks from '@/components/elements/ContentBuilder/sections/Thanks';
import EmailMe from '@/components/elements/ContentBuilder/sections/EmailMe';
import Gallery from '@/components/elements/ContentBuilder/sections/Gallery';
import Protocol from '@/components/elements/ContentBuilder/sections/Protocol';
import SplitText from '@/components/elements/ContentBuilder/sections/SplitText';
import DidYouKnow from '@/components/elements/ContentBuilder/sections/DidYouKnow';
import ContactForm from '@/components/elements/ContentBuilder/sections/ContactForm';
import EventSchedule from '@/components/elements/ContentBuilder/sections/EventSchedule';

export default {
    components: {
        'section-pdf': Pdf,
        'section-text': Text,
        'section-form': Form,
        'section-audio': Audio,
        'section-video': Video,
        'section-quote': Quote,
        'section-header': Header,
        'section-images': Images,
        'section-thanks': Thanks,
        'section-gallery': Gallery,
        'section-email-me': EmailMe,
        'section-protocol': Protocol,
        'section-split-text': SplitText,
        'section-did-you-know': DidYouKnow,
        'section-contact-form': ContactForm,
        'section-event-schedule': EventSchedule
    },

    props: {
        article: {
            type: Object,
            required: true
        },

        excludeFromPrintClassName: {
            type: String,
            required: true
        }
    },

    computed: {
        sections() {
            if (this.article.type === ArticleType.CLINICAL_RESEARCH) {
                return this.article.content.filter(
                    section => section.key !== 'split-text'
                );
            }

            return this.article.content;
        }
    }
};
</script>
